// src/components/auth/SubscriptionEnforcementCard.tsx
import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import BrandWordmark from '@/components/brand/BrandWordmark';

/**
 * SubscriptionEnforcementCard - Recovery/Enforcement Screen
 * 
 * This component is shown ONLY in these scenarios:
 * 1. User is authenticated but subscription.status !== active
 * 2. User email exists in system but no active subscription
 * 3. User attempts to access protected app routes without entitlement
 * 
 * This is NOT shown to:
 * - Cold prospects (unauthenticated visitors)
 * - Users in onboarding flow
 * 
 * Purpose: Subscription recovery and enforcement, NOT initial onboarding
 */
export default function SubscriptionEnforcementCard() {
  return (
    <div className="relative min-h-screen w-full bg-transparent">
      <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-4">
        <div className="relative w-full max-w-md rounded-2xl border border-orange-600/50 bg-slate-900/90 p-8 backdrop-blur-sm shadow-2xl">
          <div className="mb-8 flex justify-center">
            <BrandWordmark darkText={false} className="text-3xl" />
          </div>
          
          <div className="mb-6 flex justify-center">
            <AlertCircle className="h-16 w-16 text-orange-600" />
          </div>
          
          <h1 className="mb-4 text-center text-2xl font-semibold text-white">
            Complete Your Subscription
          </h1>
          
          <p className="mb-6 text-center text-sm text-white/80">
            To access your account, complete the subscription process.
          </p>
          
          <Link
            to="/subscribe"
            className="block w-full rounded-2xl border border-transparent bg-orange-600 py-3 text-center text-base font-semibold text-white transition hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500/60"
          >
            Continue to Billing
          </Link>
          
          <div className="mt-6 border-t border-slate-700 pt-6 text-center">
            <p className="text-sm text-white/60 mb-2">Need help?</p>
            <div className="flex gap-4 justify-center text-sm">
              <Link to="/terms" className="text-orange-400 underline hover:text-orange-300">
                Terms
              </Link>
              <Link to="/privacy" className="text-orange-400 underline hover:text-orange-300">
                Privacy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
